import React, { createContext, useCallback, useMemo, useState } from 'react'

import apiClient, { buildAuthHeaders } from 'services/apiClient';
export let VehicleContext = createContext()

export default function VehicleContextProvider(props) {
    const [vehWithComp, setVehWithComp] = useState([]);
    const getVehicles = useCallback(async (user, options = {}) => {
        try {
            const response = await apiClient.get('shiftware/vehicles/', {
                headers: {
                    ...buildAuthHeaders(user),
                },
                ...(options.signal ? { signal: options.signal } : {}),
            });
            return response.data;
        } catch (err) {
            throw err;
        }
    }, [])

    const refreshVehicles = useCallback(async (cookie, options = {}) => {
        if (!cookie) {
            if (!options.signal?.aborted) {
                setVehWithComp([]);
            }
            return [];
        }

        const vehicles = await getVehicles(cookie, options);
        if (options.signal?.aborted) {
            return [];
        }
        const vehiclesForOverview = vehicles.map((vehicle) => ({
            ...vehicle,
            complaints: Array.isArray(vehicle.complaints) ? vehicle.complaints : [],
        }));
        setVehWithComp(vehiclesForOverview);
        return vehiclesForOverview;
    }, [getVehicles])

    const contextValue = useMemo(() => ({
        vehWithComp,
        refreshVehicles,
        assignComplaintToVehicle: refreshVehicles,
    }), [refreshVehicles, vehWithComp])

    return (
        <VehicleContext.Provider value={contextValue}>
            {props.children}
        </VehicleContext.Provider>
    )
}
